/**
 * The access JWT, kept in memory only (fnd-lly.3).
 *
 * It used to live in browser storage, which any XSS read primitive on this
 * origin (a compromised dependency, a future innerHTML sink) can exfiltrate
 * with a single cross-origin fetch carrying the stored value in the query
 * string — no cookies, no CORS, just a portable Bearer token a `curl` can
 * replay from anywhere for as long as it's valid. A module-level variable
 * isn't readable across origins and leaves nothing behind for a script to find.
 *
 * The trade-off: it does not survive a reload. That's the point, and it's
 * why useAuth.ts's checkAuth() always re-derives it on app boot from the
 * httpOnly refresh-token cookie (POST /api/auth/refresh-token) rather than
 * from storage — the cookie was always the actual credential; this was
 * only ever a cache of what it's good for.
 */
let accessToken: string | null = null;

export function getAccessToken(): string | null {
  return accessToken;
}

export function setAccessToken(token: string | null): void {
  accessToken = token;
}

export function clearAccessToken(): void {
  accessToken = null;
}
